let environment = {
    production: false,
    url: 'https://nb.tx.puntosalud.ar/api/v1/nuvalid',
    urlturnea: 'https://app.turnea.com.ar',
    urlNuvalidLite: 'https://mpos-dev.tx.puntosalud.ar/api/v1/mposbackend'
};

let environmentReceta = {
    production: false,
    url: '/receta',
};

let environmentDispensa = {
    production: false,
    url: '/jsitelbaseservlet'
};

export { environment, environmentReceta, environmentDispensa };
